if($('.p-services').length){
	let count = 0;
	$('.p-services__item').each(function(){
		count++;
		let num = ( '00' + count ).slice( -2 );
		$(this).addClass('p-services__item--'+num);
	})
}
